import api from '@pray/shared/utils/api';

export async function endTrialEarly({ artistId = '', subscriptionId = '' }) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!subscriptionId) throw new Error('Subscription ID is required');

  const url = `/web/studio/artists/${artistId}/credits/subscription/${subscriptionId}/end-trial`;
  const response = await api.executePostRequest<undefined>(url, { allow_overages: false });

  return response.data;
}
